import { render, staticRenderFns } from "./moling_set.vue?vue&type=template&id=00d8e63f"
import script from "./moling_set.vue?vue&type=script&lang=js"
export * from "./moling_set.vue?vue&type=script&lang=js"
import style0 from "./moling_set.vue?vue&type=style&index=0&id=00d8e63f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports